"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Off = _interopRequireDefault(require("./assets/Off"));
var _On = _interopRequireDefault(require("./assets/On"));
var _jsxRuntime = require("react/jsx-runtime");
(function _() {
  var styles = ".Toggle {\n  display: flex;\n  width: max-content;\n  align-items: center;\n}\n.Toggle__input {\n  margin-right: 0.5rem;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.Toggle__input:checked ~ .Toggle__slider {\n  background-color: #008638;\n}\n.Toggle__input:checked ~ .Toggle__slider:before {\n  -webkit-transform: translateX(2.5rem);\n  -ms-transform: translateX(2.5rem);\n  transform: translateX(2.5rem);\n}\n.Toggle__slider {\n  cursor: pointer;\n  height: 2rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out;\n  width: 4.5rem;\n  background-color: #bebebe;\n  border-radius: 50rem !important;\n  align-items: center;\n  display: flex;\n  order: 2;\n}\n.Toggle__slider:before {\n  position: absolute;\n  content: \"\";\n  background-color: #ffffff;\n  transition: 0.15s;\n  border-radius: 50%;\n  height: 1.5rem;\n  width: 1.5rem;\n  margin-left: 0.25rem;\n}\n.Toggle__left {\n  order: 1;\n  margin-right: 0.5rem;\n}\n.Toggle__right {\n  order: 3;\n  margin-left: 0.5rem;\n}\n.Toggle__text {\n  line-height: 1.5rem;\n  height: 1.5rem;\n  font-weight: 700;\n  color: #262626;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n             supported by Chrome, Edge, Opera and Firefox */\n}\n.Toggle__off, .Toggle__on {\n  color: transparent;\n  cursor: pointer;\n  transition: color 0.1s ease-in;\n  margin: 0;\n}\n.Toggle__off {\n  order: 3;\n  transform: translateX(calc(-100% - 0.75rem));\n}\n.Toggle__off--svgOffset {\n  width: 21.7px;\n}\n.Toggle__on {\n  order: 1;\n  transform: translateX(calc(100% + 0.75rem));\n}\n.Toggle__on--svgOffset {\n  width: 24.5px;\n}\n.Toggle__input:not(:checked) ~ .Toggle__off {\n  color: #262626;\n}\n.Toggle__input:checked ~ .Toggle__on {\n  color: #ffffff;\n}";
  var fileName = "Toggle_Toggle";
  var element = document.querySelector("style[data-sass-component='Toggle_Toggle']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var tooLong = function tooLong(label) {
  if (label.length > 3) {
    throw new Error('The label lengths must be three or fewer characters.');
  }
};
var Toggle = function Toggle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    _ref$setValue = _ref.setValue,
    setValue = _ref$setValue === void 0 ? function () {} : _ref$setValue,
    value = _ref.value,
    type = _ref.type,
    _ref$affirmativeLabel = _ref.affirmativeLabel,
    affirmativeLabel = _ref$affirmativeLabel === void 0 ? 'On' : _ref$affirmativeLabel,
    _ref$negativeLabel = _ref.negativeLabel,
    negativeLabel = _ref$negativeLabel === void 0 ? 'Off' : _ref$negativeLabel;
  if (type === 'condensed') {
    if (typeof affirmativeLabel === 'string' && typeof negativeLabel === 'string') {
      tooLong(affirmativeLabel);
      tooLong(negativeLabel);
    } else {
      throw new Error('When property "type" is set to "condensed", labels must be strings.');
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    htmlFor: id,
    className: "Toggle ".concat(className),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "Toggle__input",
      id: id,
      type: "checkbox",
      role: "switch",
      checked: value,
      onChange: function onChange() {
        setValue(!value);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "Toggle__text Toggle__left ".concat(type ? type === 'graphical' ? 'Toggle__off Toggle__off--svgOffset' : 'Toggle__off' : ''),
      children: type === 'graphical' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Off["default"], {}) : negativeLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "Toggle__slider"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "Toggle__text Toggle__right ".concat(type ? type === 'graphical' ? 'Toggle__on Toggle__on--svgOffset' : 'Toggle__on' : ''),
      children: type === 'graphical' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_On["default"], {}) : affirmativeLabel
    })]
  });
};
var _default = Toggle;
exports["default"] = _default;